<template>
  <div :class="$style.container" id="uploadDome" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-container>
      <!--:libraryId="libraryId"-->
      <div id="collectionHome">
        <div :class="$style.left">
          <el-row>
            <el-col>
              <div style="padding-top: 8px;margin-bottom:30px;font-weight: bold;">资料发布</div>
            </el-col>
          </el-row>
          <el-row style="border-bottom: 2px dotted rgb(231, 234, 236);"> </el-row>
        </div>
        <div style="width: 100%;margin-top:10px;">
          <el-row style="margin-top:10px;">
            <el-col :span="4" style="margin-top: 5px;">
              <el-input v-model="keyword" placeholder="请输入内容"></el-input>
            </el-col>
            <el-col :span="10">
              <div style="margin-top: 5px; margin-left: 20px;">
                <el-button type="primary" size="small" icon="el-icon-search" @click.stop="handleQueryClick(true)">查询
                </el-button>
                <el-checkbox v-model="isSearchAlbum" label="筛选专辑" size="small" border
                  @change="handleOpenAlbum('','','search')" style="height: 32px; margin-left: 10px;margin-right: 0px;">
                </el-checkbox>
                <el-checkbox v-model="isSearchTags" label="筛选标签" size="small" border
                  @change="handleOpenTag('','','search')" style="height: 32px; margin-left: 10px;margin-right: 0px;">
                </el-checkbox>
                <el-radio-group v-model="searchStatusVale" size="small" @change="changeStatus"
                  style="margin-left: 10px;">
                  <el-radio-button label="">全部</el-radio-button>
                  <el-radio-button label="ACTIVE">已上架</el-radio-button>
                  <el-radio-button label="INACTIVE">已下架</el-radio-button>
                </el-radio-group>
              </div>
            </el-col>
            <el-col :span="10">
              <div style="float: right; margin-top:5px;">
                <el-button icon="el-icon-plus" type="primary" size="small" @click="addData('BLOG')">
                  链接图文H5
                </el-button>
                <el-button icon="el-icon-plus" type="primary" size="small" @click="addData('DOCUMENT')">
                  文档
                </el-button>
                <el-button icon="el-icon-plus" type="primary" size="small" @click="addData('PICTURE')">
                  图库
                </el-button>
                <el-button icon="el-icon-plus" type="primary" size="small" @click="addData('VIDEO')">
                  视频
                </el-button>
              </div>
            </el-col>
          </el-row>

          <el-table :data="tableData" border :stripe="true" header-cell-class-name="headerStyle"
            style="width: 100%;margin-top: 10px;">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="title" label="资料名称" width="290"> </el-table-column>
            <el-table-column prop="author" label="作者"> </el-table-column>
            <el-table-column label="有效期" width="200">
              <template slot-scope="scope"> {{ scope.row.start_date }} - {{ scope.row.end_date }} </template>
            </el-table-column>
            <el-table-column prop="category" label="资料类型">
              <template slot-scope="scope">
                {{ isFileType(scope.row.category) }}
              </template>
            </el-table-column>
            <el-table-column prop="size" label="文件大小">
              <template slot-scope="scope">
                <span>{{ getFileSize(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="重点推荐/分享" width="180">
              <template slot-scope="scope">
                {{ scope.row.recommended == "T" ? "重点推荐&nbsp;" : "" }} {{ scope.row.shareable == "T" ? "可分享&nbsp;" : ""
                }}{{ scope.row.classifed == "T" ? "内部资料" : "" }}
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="380">
              <template slot-scope="scope">
                <el-button @click="handleEditInfo(scope.$index, scope.row)" type="text" size="mini">基本信息 </el-button>
                <el-button @click="handleOpenUpload(scope.$index, scope.row)" type="text" size="mini">
                  内容编辑
                </el-button>
                <el-button @click="handleOpenVersionUpload(scope.$index, scope.row)" type="text" size="mini">添加新版本
                </el-button>
                <el-button @click="handleOpenAlbum(scope.$index, scope.row,'edit')" type="text" size="mini">专辑
                </el-button>
                <el-button @click="handleOpenTag(scope.$index, scope.row,'edit')" type="text" size="mini">标签
                </el-button>
                <!-- <el-popover placement="left" trigger="click" @show="handlePreviewFile(scope.row)">
                  <el-image style="width: 150px; height: 150px" fit="fill" :src="previewUrl">
                    <div slot="error" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                  <el-button slot="reference" type="text" size="mini">预览
                  </el-button>
                </el-popover> -->
                <el-button v-if="scope.row.status=='ACTIVE'" @click="handlePublished(scope.row,'INACTIVE')" type="text"
                  size="mini">下架
                </el-button>
                <el-button v-if="scope.row.status=='INACTIVE'" @click="handlePublished(scope.row,'ACTIVE')" type="text"
                  size="mini">上架
                </el-button>
                <el-button @click="downloadFile(scope.row)" type="text" size="mini">下载 </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--<Pagination :page="page" @changePage="changePageClick"></Pagination>-->
          <pagination :page="page" @changePage="changePageClick"></pagination>
        </div>

        <!-- 基本信息添加 -->
        <el-dialog :open="openDialogAdd" :visible.sync="dialogVisible_add" width="60%" :show-close="false">
          <div style="margin-top: -40px;">
            <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
              <el-col :span="9">
                <div style="color: #3998F7;padding-top: 8px;font-size: 22px">添加资料</div>
              </el-col>
              <el-col :span="15">
                <div align="right" style="float: right;display: inline-block">
                  <el-button type="primary" size="small" @click="submitForm">
                    保存
                  </el-button>
                  <el-button type="danger" size="small" @click="quxiao">
                    取消
                  </el-button>
                </div>
              </el-col>
            </el-row>

            <div class="subjectList" style="margin-top: 20px;">
              <el-row>
                <el-col :span="12">
                  <el-form ref="form" label-width="80px" class="myElForm demo-ruleForm" :model="saveObj"
                    :rules="ruleInfo" hide-required-asterisk>
                    <el-form-item label="标题" prop="title" class="upload_star">
                      <el-input v-model.trim="saveObj.title"></el-input>
                    </el-form-item>
                    <el-form-item label="作者" prop="author">
                      <el-input v-model="saveObj.author"></el-input>
                    </el-form-item>

                    <el-form-item label="有效期">
                      <el-date-picker v-model="saveObj.termOfValidity" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="简介">
                      <el-input type="textarea" v-model="saveObj.sub_title" maxlength="200" :rows="4"></el-input>
                    </el-form-item>
                    <el-form-item label="推荐话术">
                      <el-input type="textarea" v-model="saveObj.call_script" maxlength="500" :rows="4"> </el-input>
                    </el-form-item>
                    <el-form-item label="关联产品" prop="productArray">
                      <el-row>
                        <el-col>
                          <el-select @emove-tag="emoveTag" style="width: 100%" v-model="saveObj.productArray" multiple
                            filterable placeholder="请选择">
                            <el-option v-for="item in addProductArray" :key="item.product_id" :label="item.product_name"
                              :value="item.product_id"> </el-option>
                          </el-select>
                        </el-col>
                      </el-row>
                    </el-form-item>
                    <el-form-item label="文件类型">
                      <el-radio-group v-model="type" :disabled="true">
                        <el-radio label="VIDEO">视频</el-radio>
                        <el-radio label="DOCUMENT">文档</el-radio>
                        <el-radio label="PICTURE">图库</el-radio>
                        <el-radio label="BLOG">图文</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="内部资料">
                          <el-switch v-model="saveObj.classifed"> </el-switch>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6" :offset="3">
                        <el-form-item label="重点推荐">
                          <el-switch v-model="saveObj.recommended"> </el-switch>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6" :offset="3">
                        <el-form-item label="上架">
                          <el-switch v-model="saveObj.status"> </el-switch>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </el-col>
                <el-col :span="9" :offset="2">
                  <el-row>
                    <el-col :span="12">
                      <div>封面图：</div>
                      <div style="margin-top: 10px;">
                        <el-upload accept=".jpg,.png,.jpeg" :action="getUrl('PICTURE')" list-type="picture-card"
                          :on-preview="handlePictureCardPreview" :on-success="handleCoverImgSuccess"
                          :before-upload="beforeCoverImgUpload" :limit="1" :class="{ hide: uploadConverDisabled }"
                          :on-change="changeCoverUpload" :on-remove="removeCoverImg" :file-list="fileCoverList"
                          style="width: 145px; height: 145px;">
                          <i class="el-icon-plus"></i>
                          <div slot="tip" class="el-upload__tip">
                            请上传JPG或PNG格式文件，尺寸建议为1050*450
                          </div>
                        </el-upload>
                      </div>
                    </el-col>
                    <el-col :span="9" :offset="3">
                      <div>缩略图：</div>
                      <div style="margin-top: 10px;">
                        <el-upload accept=".jpg,.png,.jpeg" :action="getUrl('PICTURE')" list-type="picture-card"
                          :on-preview="handlePictureCardPreview" :on-success="handleThumImgSuccess"
                          :before-upload="beforeThumImgUpload" :limit="1" :file-list="fileThumList"
                          :class="{ hide: uploadThumDisabled }" :on-remove="removeThumImg" :on-change="changeThumUpload"
                          style="width: 145px; height: 145px;">
                          <i class="el-icon-plus"></i>
                          <div slot="tip" class="el-upload__tip">
                            请上传JPG或PNG格式文件，尺寸建议为521*521
                          </div>
                        </el-upload>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row style="margin-top: 50px;">
                    <el-col>
                      <el-form ref="formFile" :label-position="top" :model="onModelType()" :rules="ruleFile"
                        hide-required-asterisk>
                        <div v-if="type === 'VIDEO'">
                          <el-form-item label="当前版本" prop="version" class="upload_star">
                            <el-input v-model.trim="video.version"></el-input>
                          </el-form-item>
                          <el-form-item label="上传文件" ref="video" class="a_upload_file upload_star" prop="id">
                            <el-upload v-model="video.id" accept=".mp4" :action="getUrl('VIDEO')"
                              :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                              :on-success="handleVideoSuccess" :before-upload="beforeVideoUpload" multiple :limit="2"
                              :on-exceed="handleExceed" :file-list="fileList">
                              <el-button size="small" type="primary" :disabled="!canUpload">
                                点击上传
                              </el-button>

                              <el-row slot="tip" class="el-upload__tip2"
                                style="font-size: 12px;margin-top: 8px;width: 320px;font-weight: 400;">
                                您可以上传mp4格式的视频文件,文件大小不能超过100M!
                              </el-row>
                            </el-upload>

                            <!-- <span style="margin-top: -10px;color: #4A90E2;font-size: 12px;font-weight: bold;position: relative;top: -8px;" slot="tip" class="el-upload__tip1">
                                请待进度条走到100%并出现
                              </span>
                              <span>
                                <i class="el-icon-circle-check" style="color: green;font-size: 16px;position:relative;left: 71px;top: 82px"></i>
                              </span>
                              <span style="margin-top: -10px;margin-left: 20px;position: relative;top: -8px" slot="tip" class="el-upload__tip">
                                之后保存，方为上传成功
                              </span> -->
                            <!-- <el-row> -->
                            <div style="color: #4A90E2;font-weight: bold;font-size: 13px;" slot="tip">
                              请待进度条走到 100%并出现
                              <i class="el-icon-circle-check"
                                style="color: green;font-size: 16px;margin-left: 5px;margin-right: 5px">
                              </i>之后保存，方为上传成功!
                            </div>
                            <!-- </el-row> -->
                          </el-form-item>
                          <el-row style="margin-top: 30px">
                            <el-col :span="14">
                              <el-form-item label-width="70px" label="播放时长" class="video" style="margin-top: -10px">
                                <el-input v-model="video.min" @input="imposeM(video.min, 'video')" style="width: 80px"
                                  type="number"></el-input>
                                <span :class="$style.font">分</span>
                              </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="2">
                              <el-form-item prop="miao" label=" " style="margin-top: -10px" class="video">
                                <el-input v-model="video.miao" @input="impose(video.miao, 'video')" style="width: 80px"
                                  type="number"></el-input>
                                <span :class="$style.font">秒</span>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </div>

                        <div v-if="type === 'DOCUMENT'">
                          <el-form-item label="当前版本" prop="version" class="upload_star">
                            <el-input v-model.trim="doc.version"></el-input>
                          </el-form-item>
                          <el-form-item label="上传文件" ref="doc" class="a_upload_file upload_star" prop="pdfId">
                            <el-upload accept=".pdf" :action="getUrl('DOCUMENT')" :on-preview="handlePreview"
                              :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handlePDFSuccess"
                              :before-upload="beforePDFUpload" multiple :limit="2" :on-exceed="handleExceed"
                              :file-list="fileList">
                              <el-button size="small" type="primary" :disabled="!canUpload">
                                点击上传
                              </el-button>
                              <div slot="tip" class="el-upload__tip2" style="font-size: 12px;margin-top: 8px">
                                请上传PDF格式的幻灯片文件, 文件大小不能超过50M
                              </div>
                            </el-upload>
                            <!-- <span style="margin-top: -10px;color: #4A90E2;font-size: 12px;font-weight: bold;position: relative;top: -8px;" slot="tip" class="el-upload__tip1">
                              请待进度条走到100%并出现
                            </span>
                            <span>
                              <i class="el-icon-circle-check" style="color: green;font-size: 16px;position:relative;left: 71px;top: 82px"></i>
                            </span>
                            <span style="margin-top: -10px;margin-left: 20px;position: relative;top: -8px" slot="tip" class="el-upload__tip">
                              之后保存，方为上传成功
                            </span> -->
                            <el-row>
                              <div style="color: #4A90E2;font-weight: bold;font-size: 13px;">
                                请待进度条走到 100%并出现
                                <i class="el-icon-circle-check"
                                  style="color: green;font-size: 16px;margin-left: 5px;margin-right: 5px">
                                </i>之后保存，方为上传成功!
                              </div>
                            </el-row>
                          </el-form-item>
                        </div>
                        <!-- fuckkk -->
                        <div v-if="type === 'PICTURE'">
                          <el-form-item label="当前版本" prop="version" class="upload_star">
                            <el-input v-model.trim="pic.version"></el-input>
                          </el-form-item>
                          <div style="width: 150px; margin-top: -20px;">
                            <el-form-item label="上传文件" ref="pic" class="upload_star" prop="picsUrls">
                              <div style="display:flex;flex-flow:row wrap ;width: 320px;">
                                <el-upload accept=".jpg,.png,.jpeg" :action="getUrl('PICTURE')" list-type="picture-card"
                                  :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                                  :on-success="handleImgSuccess" :before-upload="beforeImgUpload" :file-list="fileList">
                                  <i class="el-icon-plus"></i>
                                </el-upload>
                              </div>
                            </el-form-item>
                          </div>
                          <p :class="$style.tip">你可以上传多张JPG或PNG格式的图片文件, 单个文件大小不能超过20M。</p>
                          <p :class="$style.tip" style="color: #4A90E2;font-weight: bold;">
                            请待进度条走到 100%并出现<i class="el-icon-circle-check"
                              style="color: green;font-size: 16px;margin-left: 5px;margin-right: 5px"></i>之后保存，方为上传成功!
                          </p>
                        </div>

                        <div v-if="type === 'BLOG'">
                          <el-form-item label="当前版本" prop="version" class="upload_star">
                            <el-input v-model.trim="text.version"></el-input>
                          </el-form-item>
                          <el-form-item label="图文链接" prop="blogUrl" class="upload_star">
                            <!-- <Editor @html="handleHtmlChange" :text="ht" /> -->
                            <el-input type="textarea" v-model="text.blogUrl" maxlength="200" :rows="4"> </el-input>
                          </el-form-item>
                        </div>
                      </el-form>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-dialog>

        <!-- 基本信息编辑 -->
        <el-dialog :open="openDialogEdit" :visible.sync="dialogVisible_edit" width="60%" :show-close="false">
          <div style="margin-top: -40px;">
            <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
              <el-col :span="9">
                <div style="color: #3998F7;padding-top: 8px;font-size: 22px">基本信息</div>
              </el-col>
              <el-col :span="15">
                <div align="right" style="float: right;display: inline-block">
                  <el-button type="primary" size="small" @click="submitForm">
                    保存
                  </el-button>
                  <el-button type="danger" size="small" @click="quxiao">
                    取消
                  </el-button>
                </div>
              </el-col>
            </el-row>

            <div class="subjectList" style="margin-top: 20px;">
              <el-form ref="form" label-width="80px" class="myElForm demo-ruleForm" :model="saveObj" :rules="ruleInfo"
                hide-required-asterisk>
                <el-row>
                  <el-col :span="14">
                    <el-form-item label="标题" prop="title" class="upload_star">
                      <el-input v-model="saveObj.title"></el-input>
                    </el-form-item>
                    <el-row>
                      <el-col :span="11">
                        <!-- <el-form-item label="当前版本" prop="version" class="upload_star">
                                                    <el-input v-model="saveObj.version"></el-input>
                                                </el-form-item> -->
                        <el-form-item label="当前版本" prop="versionArray">
                          <el-select style="width: 100%" v-model="saveObj.version" placeholder="请选择">
                            <el-option v-for="item in versionArray" :key="item.version" :label="item.version"
                              :value="item.version"> </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="2">
                        <el-form-item label="作者" prop="author">
                          <el-input v-model="saveObj.author"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-form-item label="有效期">
                      <el-date-picker v-model="saveObj.termOfValidity" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" style="width: 100%;">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="简介">
                      <el-input type="textarea" v-model="saveObj.sub_title" maxlength="200" :rows="4"></el-input>
                    </el-form-item>
                    <el-form-item label="推荐话术">
                      <el-input type="textarea" v-model="saveObj.call_script" maxlength="500" :rows="4"> </el-input>
                    </el-form-item>
                    <el-form-item label="关联产品" prop="productArray">
                      <el-row>
                        <el-col>
                          <el-select @emove-tag="emoveTag" style="width: 100%" v-model="saveObj.productArray" multiple
                            filterable placeholder="请选择">
                            <el-option v-for="item in addProductArray" :key="item.product_id" :label="item.product_name"
                              :value="item.product_id"> </el-option>
                          </el-select>
                        </el-col>
                      </el-row>
                    </el-form-item>
                    <el-form-item label="文件类型">
                      <el-radio-group v-model="type" :disabled="false" disabled>
                        <el-radio label="VIDEO">视频</el-radio>
                        <el-radio label="DOCUMENT">文档</el-radio>
                        <el-radio label="PICTURE">图库</el-radio>
                        <el-radio label="BLOG">图文</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="内部资料">
                          <el-switch v-model="saveObj.classifed"> </el-switch>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6" :offset="3">
                        <el-form-item label="重点推荐">
                          <el-switch v-model="saveObj.recommended"> </el-switch>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6" :offset="3">
                        <el-form-item label="上架">
                          <el-switch v-model="saveObj.status">
                          </el-switch>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8" :offset="2">
                    <div>封面图：</div>
                    <div style="margin-top: 10px;">
                      <el-upload accept=".jpg,.png,.jpeg" :action="getUrl('PICTURE')" list-type="picture-card"
                        :on-preview="handlePictureCardPreview" :on-success="handleCoverImgSuccess"
                        :before-upload="beforeCoverImgUpload" :limit="1" :class="{ hide: uploadConverDisabled }"
                        :on-change="changeCoverUpload" :on-remove="removeCoverImg" :file-list="fileCoverList">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>
                    <div style="font-size: 12px;margin-top: 10px;;">请上传JPG或PNG格式文件，尺寸建议为1050*450</div>

                    <div style="margin-top: 50px;">缩略图：</div>
                    <div style="margin-top: 10px;">
                      <el-upload accept=".jpg,.png,.jpeg" :action="getUrl('PICTURE')" list-type="picture-card"
                        :on-preview="handlePictureCardPreview" :on-success="handleThumImgSuccess"
                        :before-upload="beforeThumImgUpload" :limit="1" :file-list="fileThumList"
                        :class="{ hide: uploadThumDisabled }" :on-remove="removeThumImg" :on-change="changeThumUpload">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>
                    <div style="font-size: 12px;margin-top: 10px;;">请上传JPG或PNG格式文件，尺寸建议为521*521</div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-dialog>

        <!--内容编辑-->
        <el-dialog :open="openUploadDialog" :visible.sync="dialogUploadVisible" width="60%" :show-close="false">
          <div style="margin-top: -40px;">
            <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
              <el-col :span="9">
                <div style="color: #3998F7;padding-top: 8px;font-size: 22px;float: left;">内容编辑</div>
                <div style="margin-left: 12px;font-size: 22px;float: left;">
                  <el-select @emove-tag="emoveTag" style="width: 140px;" v-model="uploadObj.version" placeholder="请选择"
                    @change="changeSelectVersion">
                    <el-option v-for="item in versionArray" :key="item.version" :label="item.versionText"
                      :value="item.version"> </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="15">
                <div align="right" style="float: right;">
                  <span style="color: #FF9901;">最后更新日期 </span><span style="color:#87909A;margin-right: 10px;">{{
                    uploadObj.lastdate
                    }}</span>
                  <!-- <el-button size="mini" type="success">效果预览</el-button> -->
                  <el-popover placement="left" trigger="click" @show="handlePreviewFile()">
                    <el-image style="width: 150px; height: 150px" fit="fill" :src="previewUrl">
                      <div slot="error" class="image-slot">
                        加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                    <el-button slot="reference" type="success" icon="el-icon-view" size="small">效果预览
                    </el-button>
                  </el-popover>
                  <el-button type="warning" style="margin-left: 10px;" icon="el-icon-s-promotion" size="small"
                    :disabled="!canUpload" @click="handleEditUpload('ACTIVE')" v-if="uploadObj.status!='ACTIVE'">
                    发布
                  </el-button>
                  <el-button type="primary" size="small" :disabled="!canUpload" @click="handleEditUpload('DRAFT')"
                    v-if="uploadObj.status!='ACTIVE'" style="margin-left: 10px;">
                    保存
                  </el-button>
                  <el-button type="danger" size="small" @click="quxiao">
                    取消
                  </el-button>
                </div>
              </el-col>
            </el-row>

            <div class="subjectList" style="margin-top: 20px;">
              <el-form ref="formContent" label-width="100px" :rules="ruleFile2" class="myElForm demo-ruleForm"
                :model="onModelType()" hide-required-asterisk>
                <div v-if="type === 'VIDEO'">
                  <el-form-item label="版本说明">
                    <el-input type="textarea" v-model="uploadObj.comments" maxlength="200" :rows="4"
                      :disabled="uploadObj.status=='ACTIVE'"></el-input>
                  </el-form-item>
                  <el-form-item label="上传文件" :ref="video" class="a_upload_file upload_star" prop="id">
                    <el-upload v-model="video.id" accept=".mp4" :disabled="uploadObj.status=='ACTIVE'"
                      :action="getUrl('VIDEO')" :on-preview="handlePreview" :on-remove="handleRemove"
                      :before-remove="beforeRemove" :on-success="handleVideoSuccess" :before-upload="beforeVideoUpload"
                      multiple :limit="2" :on-exceed="handleExceed" :file-list="fileList">
                      <el-button size="small" type="primary" :disabled="!canUpload">点击上传 </el-button>
                      <div slot="tip" class="el-upload__tip2" style="font-size: 12px;margin-top: 8px">
                        您可以上传mp4格式的视频文件,文件大小不能超过100M!
                      </div>
                      <span
                        style="margin-top: -10px;color: #4A90E2;font-size: 12px;font-weight: bold;position: relative;top: -8px;"
                        slot="tip" class="el-upload__tip1">
                        请待进度条走到100%并出现
                      </span>
                      <span>
                        <i class="el-icon-circle-check"
                          style="color: green;font-size: 16px;position:relative;left: 71px;top: 82px"></i>
                      </span>
                      <span style="margin-top: -10px;margin-left: 20px;position: relative;top: -8px" slot="tip"
                        class="el-upload__tip">
                        之后保存，方为上传成功
                      </span>
                    </el-upload>
                  </el-form-item>
                  <el-row style="margin-top: 30px">
                    <el-col :span="8">
                      <el-form-item label="播放时长" class="video" style="margin-top: -10px">
                        <el-input v-model="video.min" :disabled="uploadObj.status=='ACTIVE'"
                          @input="imposeM(video.min, 'video')" style="width: 100px" type="number"></el-input>
                        <span :class="$style.font">分</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item prop="miao" style="margin-top: -10px" class="myelformItem">
                        <el-input v-model="video.miao" :disabled="uploadObj.status=='ACTIVE'"
                          @input="impose(video.miao, 'video')" style="width: 100px" type="number"></el-input>
                        <span :class="$style.font">秒</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>

                <div v-if="type === 'DOCUMENT'">
                  <el-form-item label="简介">
                    <el-input type="textarea" :disabled="uploadObj.status=='ACTIVE'" maxlength="200"
                      v-model="uploadObj.comments" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="上传文件" ref="doc" class="a_upload_file upload_star" prop="pdfId">
                    <el-upload accept=".pdf" :disabled="uploadObj.status=='ACTIVE'" :action="getUrl('DOCUMENT')"
                      :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                      :on-success="handlePDFSuccess" :before-upload="beforePDFUpload" multiple :limit="2"
                      :on-exceed="handleExceed" :file-list="fileList">
                      <el-button size="small" type="primary" :disabled="!canUpload">点击上传 </el-button>
                      <div slot="tip" class="el-upload__tip2" style="font-size: 12px;margin-top: 8px">
                        请上传PDF格式的幻灯片文件, 文件大小不能超过50M
                      </div>
                      <span
                        style="margin-top: -10px;color: #4A90E2;font-size: 12px;font-weight: bold;position: relative;top: -8px;"
                        slot="tip" class="el-upload__tip1">
                        请待进度条走到100%并出现
                      </span>
                      <span>
                        <i class="el-icon-circle-check"
                          style="color: green;font-size: 16px;position:relative;left: 71px;top: 82px"></i>
                      </span>
                      <span style="margin-top: -10px;margin-left: 20px;position: relative;top: -8px" slot="tip"
                        class="el-upload__tip">
                        之后保存，方为上传成功
                      </span>
                    </el-upload>
                  </el-form-item>
                </div>
                <!-- fuckkk -->
                <div v-if="type === 'PICTURE'">
                  <el-form-item label="版本说明">
                    <el-input type="textarea" :disabled="uploadObj.status=='ACTIVE'" maxlength="200"
                      v-model="uploadObj.comments" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="上传文件" class="a_upload_file upload_star" prop="picsUrls">
                    <el-upload accept=".jpg,.png,.jpeg" :disabled="uploadObj.status=='ACTIVE'"
                      :action="getUrl('PICTURE')" list-type="picture-card" :on-preview="handlePictureCardPreview"
                      :on-remove="handleRemove" :on-success="handleImgSuccess" :before-upload="beforeImgUpload"
                      :file-list="fileList"><i class="el-icon-plus"></i>
                    </el-upload>

                    <p :class="$style.tip">你可以上传多张JPG或PNG格式的图片文件, 单个文件大小不能超过20M。</p>
                    <p :class="$style.tip" style="color: #4A90E2;font-weight: bold;">
                      请待进度条走到 100%并出现<i class="el-icon-circle-check"
                        style="color: green;font-size: 16px;margin-left: 5px;margin-right: 5px"></i>之后保存，方为上传成功!
                    </p>
                  </el-form-item>
                </div>

                <div v-if="type === 'BLOG'">
                  <el-form-item label="版本说明">
                    <el-input type="textarea" :disabled="uploadObj.status=='ACTIVE'" maxlength="200"
                      v-model="uploadObj.comments" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="图文链接" prop="id">
                    <!-- <Editor @html="handleHtmlChange" :text="ht" /> -->
                    <el-input type="textarea" :disabled="uploadObj.status=='ACTIVE'" maxlength="200"
                      v-model="uploadObj.blogUrl" :rows="4"></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
        </el-dialog>

        <!--上传版本-->
        <!-- 添加新版本 -->
        <el-dialog :open="openUploadVersionDialog" :visible.sync="dialogUploadVersionVisible" width="60%"
          :show-close="false">
          <div style="margin-top: -40px;">
            <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
              <el-col :span="9">
                <div style="color: #3998F7;padding-top: 8px;font-size: 22px">添加新版本</div>
              </el-col>
              <el-col :span="15">
                <div align="right" style="float: right;">
                  <el-button type="warning" icon="el-icon-s-promotion" size="small" :disabled="!canUpload"
                    @click="handleAddVersionUpload('ACTIVE')" style="margin-left: 10px;">
                    发布
                  </el-button>
                  <el-button type="primary" size="small" :disabled="!canUpload" @click="handleAddVersionUpload('DRAFT')"
                    style="margin-left: 10px;">
                    保存
                  </el-button>
                  <el-button type="danger" size="small" @click="quxiao">
                    取消
                  </el-button>
                </div>
              </el-col>
            </el-row>

            <div class="subjectList" style="margin-top: 20px;">
              <el-form ref="formVersion" label-width="100px" class="myElForm demo-ruleForm" :model="uploadObj"
                :rules="ruleVersion" hide-required-asterisk>
                <div v-if="type === 'VIDEO'">
                  <el-form-item label="新版本号" prop="version">
                    <el-input type="text" v-model="uploadObj.version" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="版本说明">
                    <el-input type="textarea" v-model="uploadObj.comments" maxlength="200" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="上传文件" ref="video" class="a_upload_file upload_star" prop="id">
                    <el-upload v-model="video.id" accept=".mp4" :action="getUrl('VIDEO')" :on-preview="handlePreview"
                      :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handleVideoSuccess"
                      :before-upload="beforeVideoUpload" multiple :limit="2" :on-exceed="handleExceed"
                      :file-list="fileList">
                      <el-button size="small" type="primary" :disabled="!canUpload">点击上传 </el-button>
                      <div slot="tip" class="el-upload__tip2" style="font-size: 12px;margin-top: 8px">
                        您可以上传mp4格式的视频文件,文件大小不能超过100M!
                      </div>
                      <span
                        style="margin-top: -10px;color: #4A90E2;font-size: 12px;font-weight: bold;position: relative;top: -8px;"
                        slot="tip" class="el-upload__tip1">
                        请待进度条走到100%并出现
                      </span>
                      <span>
                        <i class="el-icon-circle-check"
                          style="color: green;font-size: 16px;position:relative;left: 71px;top: 82px"></i>
                      </span>
                      <span style="margin-top: -10px;margin-left: 20px;position: relative;top: -8px" slot="tip"
                        class="el-upload__tip">
                        之后保存，方为上传成功
                      </span>
                    </el-upload>
                  </el-form-item>
                  <el-row style="margin-top: 30px">
                    <el-col :span="8">
                      <el-form-item label="播放时长" class="video" style="margin-top: -10px">
                        <el-input v-model="video.min" @input="imposeM(video.min, 'video')" style="width: 100px"
                          type="number"></el-input>
                        <span :class="$style.font">分</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item prop="miao" style="margin-top: -10px" class="myelformItem">
                        <el-input v-model="video.miao" @input="impose(video.miao, 'video')" style="width: 100px"
                          type="number"></el-input>
                        <span :class="$style.font">秒</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>

                <div v-if="type === 'DOCUMENT'">
                  <el-form-item label="新版本号" prop="version">
                    <el-input type="text" v-model="uploadObj.version" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="简介">
                    <el-input type="textarea" v-model="uploadObj.comments" maxlength="200" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="上传文件" ref="doc" class="a_upload_file upload_star" prop="pdfId">
                    <el-upload accept=".pdf" :action="getUrl('DOCUMENT')" :on-preview="handlePreview"
                      :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handlePDFSuccess"
                      :before-upload="beforePDFUpload" multiple :limit="2" :on-exceed="handleExceed"
                      :file-list="fileList">
                      <el-button size="small" type="primary" :disabled="!canUpload">点击上传 </el-button>
                      <div slot="tip" class="el-upload__tip2" style="font-size: 12px;margin-top: 8px">
                        请上传PDF格式的幻灯片文件, 文件大小不能超过50M
                      </div>
                      <span
                        style="margin-top: -10px;color: #4A90E2;font-size: 12px;font-weight: bold;position: relative;top: -8px;"
                        slot="tip" class="el-upload__tip1">
                        请待进度条走到100%并出现
                      </span>
                      <span>
                        <i class="el-icon-circle-check"
                          style="color: green;font-size: 16px;position:relative;left: 71px;top: 82px"></i>
                      </span>
                      <span style="margin-top: -10px;margin-left: 20px;position: relative;top: -8px" slot="tip"
                        class="el-upload__tip">
                        之后保存，方为上传成功
                      </span>
                    </el-upload>
                  </el-form-item>
                </div>
                <!-- fuckkk -->
                <div v-if="type === 'PICTURE'">
                  <el-form-item label="新版本号" prop="version">
                    <el-input type="text" v-model="uploadObj.version" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="版本说明">
                    <el-input type="textarea" v-model="uploadObj.comments" maxlength="200" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="上传文件" ref="picUpload" class="a_upload_file upload_star" prop="picsUrls">
                    <el-upload accept=".jpg,.png,.jpeg" :action="getUrl('PICTURE')" list-type="picture-card"
                      :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleImgSuccess"
                      :before-upload="beforeImgUpload" :file-list="fileList">
                      <i class="el-icon-plus"></i>
                    </el-upload>

                    <p :class="$style.tip">你可以上传多张JPG或PNG格式的图片文件, 单个文件大小不能超过20M。</p>
                    <p :class="$style.tip" style="color: #4A90E2;font-weight: bold;">
                      请待进度条走到 100%并出现<i class="el-icon-circle-check"
                        style="color: green;font-size: 16px;margin-left: 5px;margin-right: 5px"></i>之后保存，方为上传成功!
                    </p>
                  </el-form-item>
                </div>

                <div v-if="type === 'BLOG'">
                  <el-form-item label="新版本号" prop="version">
                    <el-input type="text" v-model="uploadObj.version" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="版本说明">
                    <el-input type="textarea" v-model="uploadObj.comments" maxlength="200" :rows="4"></el-input>
                  </el-form-item>
                  <el-form-item label="图文链接" prop="id">
                    <!-- <Editor @html="handleHtmlChange" :text="ht" /> -->
                    <el-input type="textarea" v-model="uploadObj.blogUrl" maxlength="200" :rows="4"></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
        </el-dialog>

        <!-- 专辑 -->
        <el-dialog :open="openDialogAlbum" :visible.sync="dialogVisible_Album" width="50%" :show-close="false">
          <div style="margin-top: -40px;">
            <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
              <el-col :span="9">
                <div style="color: #3998F7;padding-top: 8px;font-size: 22px">所属专辑</div>
              </el-col>
              <el-col :span="15">
                <div align="right" style="float: right;display: inline-block">
                  <el-button type="primary" size="small" @click="handleSureAlbum" v-if="openAlbumTagType=='search'">
                    确定
                  </el-button>
                  <el-button type="primary" size="small" @click="handleSaveAlbum" v-if="openAlbumTagType=='edit'">
                    保存
                  </el-button>
                  <el-button type="danger" size="small" @click="quxiao">
                    取消
                  </el-button>
                </div>
              </el-col>
            </el-row>

            <div class="subjectList" style="margin-top: 20px;">
              <el-form ref="form" label-width="80px" class="myElForm demo-ruleForm" hide-required-asterisk>
                <el-row>
                  <el-col :span="24" v-for="(item, index) in albumList">
                    <div style="margin-top: 10px;margin-bottom:20px;">{{ item.title }}</div>
                    <el-checkbox-group v-model="albumCheckList" style="margin-bottom: 20px;" @change="changeAlbum">
                      <el-checkbox v-for="subitem in item.subCatalog" :label="subitem.catalog_id"
                        :key="subitem.catalog_id">{{ subitem.title }}</el-checkbox>
                    </el-checkbox-group>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-dialog>

        <!-- 标签 -->
        <el-dialog :open="openDialogTag" :visible.sync="dialogVisible_Tag" width="500" :show-close="false">
          <div style="margin-top: -40px;">
            <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 10px;">
              <el-col :span="9">
                <div style="color: #3998F7;padding-top: 8px;font-size: 22px">设定标签</div>
              </el-col>
              <el-col :span="15">
                <div align="right" style="width: 50%;float: right;display: inline-block">
                  <el-button type="primary" size="small" @click="handleSureTag" v-if="openAlbumTagType=='search'">
                    确定
                  </el-button>
                  <el-button type="primary" size="small" @click="handleSaveTag" v-if="openAlbumTagType=='edit'">
                    保存
                  </el-button>
                  <el-button type="danger" size="small" @click="quxiao">
                    取消
                  </el-button>
                </div>
              </el-col>
            </el-row>

            <div class="subjectList" style="margin-top: 20px;">
              <el-form ref="form" label-width="80px" class="myElForm demo-ruleForm" hide-required-asterisk>
                <el-row>
                  <el-col :span="24" v-for="(item, index) in tagList">
                    <div style="margin-top: 10px;margin-bottom:20px;">{{ item.title }}</div>
                    <el-checkbox-group v-model="tagCheckList" style="margin-bottom: 20px;" @change="changeTag">
                      <el-checkbox v-for="subitem in item.subTag" :label="subitem.tag_id" :key="subitem.tag_id">{{
                        subitem.text }}</el-checkbox>
                    </el-checkbox-group>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </el-dialog>
      </div>
    </el-container>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" style="position: relative; z-index: 9999" alt="" />
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from "../../components/pagination";
  import http from "../../APIService/http";
  import { bus } from "../../router/index.js";
  import Editor from "./components/etitor";
  import http2 from "../../APIService/http2";
  import moment from "moment";

  export default {
    data() {
      return {
        ruleInfo: {
          title: [{ required: true, trigger: "blur", message: "此项不能为空" }],
          // miao: [{ required: true, message: "不能为空", trigger: "blur" }],
          // picsUrls: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          // id: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          // pdfId: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          // blogUrl: [{ required: true, message: "链接不能为空", trigger: "blur" }],
        },
        ruleFile: {
          version: [{ required: true, trigger: "blur", message: "此项不能为空" }],
          miao: [{ required: true, message: "不能为空", trigger: "blur" }],
          picsUrls: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          id: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          pdfId: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          blogUrl: [{ required: true, message: "链接不能为空", trigger: "blur" }],
        },
        ruleFile2: {
          miao: [{ required: true, message: "不能为空", trigger: "blur" }],
          picsUrls: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          id: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          pdfId: [{ required: true, message: "文件不能为空", trigger: "blur" }],
          blogUrl: [{ required: true, message: "链接不能为空", trigger: "blur" }],
        },
        ruleVersion: {
          version: [{ required: true, trigger: "blur", message: "此项不能为空" }],
        },
        addEditType: "add",
        searchStatusVale: "",
        openAlbumTagType: "edit",
        saveObj: {
          formContent: "",
          library_id: "",
          material_id: "",
          title: "",
          sub_title: "",
          author: "",
          termOfValidity: [],
          call_script: "", // 视频id
          productArray: [],
          versionArray: [],
          version: "",
          category: "",
          classifed: false, //内部资料
          recommended: false, //重点推荐
          status: false, //已发布
          thumbnail: {
            name: "",
            id: "",
            url: "",
            file_type: "",
            file_size: "",
          },
          coverImg: {
            name: "",
            id: "",
            url: "",
            size: "",
            filename: "",
            type: "",
            file_type: "",
            file_size: "",
          },
          category: "PICTURE",
          blogUrl: "",
          miao: "",
        },
        uploadObj: {
          comments: "",
          version: "",
          lastdate: "",
          category: "PICTURE",
          blogUrl: "",
          files: [],
        },

        video: {
          version: "",
          title: "",
          desc: "",
          videoUrl: "",
          min: "",
          miao: "",
          id: "", // 视频id
          type: "",
          fileName: "",
        },
        doc: {
          version: "",
          title: "",
          desc: "",
          pdfUrl: "",
          pdfId: "",
          pdfType: "",
          fileName: "",
        },
        pic: {
          version: "",
          title: "",
          desc: "",
          picsUrls: [],
        },
        text: {
          version: "",
          blogUrl: "",
        },
        previewUrl: "",
        fileList: [],
        fileSaveList: [],
        fileCoverList: [],
        fileThumList: [],
        Dlist: [],
        Mlist: [],
        Tlist: [],
        tab: "视频",
        type: "VIDEO",
        canUpload: true,
        loading: false,
        tableData: [],
        addProductArray: [],
        versionArray: [],
        page: {
          current: 1,
          size: 10,
          total: 0,
        },
        keyword: "",
        file_size: 0,
        dialogImageUrl: "",
        dialogVisible_add: false,
        dialogVisible_edit: false,
        dialogVisible_Album: false,
        dialogVisible_Tag: false,
        dialogVisible: false,
        dialogUploadVisible: false,
        dialogUploadVersionVisible: false,
        albumList: [],
        albumCheckList: [],
        albumSearchCheckList: [],
        isSearchAlbum: false,
        tagList: [],
        tagCheckList: [],
        tagSearchCheckList: [],
        isSearchTags: false,
        isSearchSelect: false,
        selectRow: {},
        uploadConverDisabled: false,
        uploadThumDisabled: false,
      };
    },
    created() {
      this.myfileList();
      this.addProductArray_fn();
      this.getAlbumList();
      this.getTagList();
    },
    mounted() {
      //            this.myfileList()
    },
    watch: {
      tab: function (newV, oldV) { },
    },
    components: {
      Pagination,
      Editor,
    },
    computed: {},
    methods: {
      emoveTag(tag) {
        //console.log(tag)
      },
      changePageClick(page, size) {
        debugger;
        if (page) {
          this.page.current = page;
        }

        if (size) {
          this.page.size = size;
        }
        this.myfileList(false);
      },
      handleQueryClick(isSearch) {
        if (isSearch) {
          this.page = {
            current: 1,
            size: 10,
            total: 0,
          };
        }
        this.myfileList(isSearch);
      },
      changeStatus(e) {
        console.log("---------------------------");
        console.log(e);
        this.searchStatusVale = e;
        this.myfileList(true)
      },
      isFileType(type) {
        switch (type) {
          case "PICTURE":
            return "图库";
            break;
          case "VIDEO":
            return "视频";
            break;
          case "DOCUMENT":
            return "文档";
            break;
          case "BLOG":
            return "图文";
            break;
        }
      },
      getFileSize(row) {
        let num = row.size;
        let size_text = "尚未上传";
        if (num && num != 0) {
          size_text = (parseInt(num) / 1024).toFixed(0); //kb
          if (size_text >= 1024) {
            size_text = (size_text / 1024).toFixed(0); //mb

            size_text = size_text + "MB";
          } else {
            size_text = size_text + "KB";
          }
        }
        if(row.category==="BLOG")
        {
          size_text="N/A"
        }
        return size_text;
      },

      imposeM(v, t) {
        if (t === "video") {
          if (parseInt(v) < 0) {
            this.video.min = 0;
          }

          if (this.video.miao === "") {
            this.video.miao = 0;
          }
        }
      },
      impose(v, t) {
        if (t === "video") {
          if (parseInt(v) < 0) {
            this.video.miao = 0;
          }
          if (parseInt(v) > 59) {
            this.video.miao = 59;
          }
        }
      },
      onModelType() {
        debugger;
        if (this.type == "VIDEO") {
          return this.video;
        } else if (this.type == "DOCUMENT") {
          return this.doc;
        } else if (this.type == "PICTURE") {
          return this.pic;
        } else if (this.type == "BLOG") {
          return this.text;
        }
      },
      async addProductArray_fn() {
        try {
          let data = this.$store.getters.getDataInfo;
          data.tenant_id = this.$store.getters.getUser.tenant_id;

          //this.loading = false
          await http.post("/echo/webLibrary/getProById", data).then((res) => {
            console.log(res, 5555);
            this.addProductArray = res.data;
          });
        } catch (e) { }
      },
      async getVersionArray_fn(index, row, status) {
        try {
          this.versionArray = [];

          let data = this.$store.getters.getDataInfo;
          data.tenant_id = this.$store.getters.getUser.tenant_id;
          data.library_id = row.library_id;
          data.material_id = row.material_id;
          data.status = status;

          //this.loading = false
          await http.post("/echo/webLibrary/getVersionArray", data).then((res) => {
            for (const item of res.data) {
              let versionObj = {
                version: item.version,
                versionText: item.version == row.version ? item.version + " (当前版本)" : item.version,
              };
              this.versionArray.push(versionObj);
            }
          });
        } catch (e) { }
      },
      async myfileList(issearch) {
        if (issearch) {
          this.page.current = 1;
        }
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            limit: this.page.size,
            offset: this.page.current - 1,
            keyword: this.keyword,
            status: this.searchStatusVale,
            catalogIds: this.albumCheckList,
            tags: this.tagCheckList
          };
          this.loading = true;
          await http.post("/echo/webLibrary/getLibraryList", data).then((res) => {
            debugger;
            this.loading = false;
            // console.log(res)
            this.tableData = res.data.data;
            this.page.total = res.data.arrayCount;
          });
        } catch (err) {
          this.loading = false;
        } finally {
          this.loading = false;
        }
      },
      //获取专辑列表
      async getAlbumList() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            category: "LIBRARY_MATERIAL",
          };
          // this.loading = true;
          await http.post("/echo/webLibrary/getAlbumById", data).then((res) => {
            debugger;
            this.loading = false;
            console.log(res);
            this.albumList = res.data;
          });
        } catch (err) {
          this.loading = false;
        } finally {
          this.loading = false;
        }
      },
      //获取tag列表
      async getTagList() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            category: "LIBRARY_MATERIAL"
          };
          // this.loading = true;
          await http.post("/echo/tags/getTagGroupList", data).then((res) => {
            debugger;
            this.loading = false;
            console.log(res);
            this.tagList = res.data;
          });
        } catch (err) {
          this.loading = false;
        } finally {
          this.loading = false;
        }
      },
      getUrl(category) {
        return (
          "/files/uploadfile?tenant_id=" +
          this.$store.getters.getUser.tenant_id +
          "&reference_obj=LIBRARY_MATERIAL&category=" +
          category +
          "&user_id=" +
          this.$store.getters.getUser.user_id
        );
      },
      addData(type) {
        this.quxiao(false);
        this.saveObj.classifed = false;
        this.saveObj.recommended = false;
        this.saveObj.status = false;
        this.addEditType = "add";
        this.type = type;
        this.fileCoverList = [];
        this.fileThumList = [];
        this.uploadConverDisabled = false;
        this.uploadThumDisabled = false;
        this.dialogVisible_add = true;
      },
      //基本信息
      async handleEditInfo(index, row) {
        this.addEditType = "edit";
        this.dialogVisible_edit = true;
        this.fileThumList = [];
        this.fileCoverList = [];
        this.saveObj.library_id = row.library_id;
        this.saveObj.material_id = row.material_id;

        await this.getVersionArray_fn(index, row, "ACTIVE");
        console.log(row);

        this.saveObj.title = row.title;
        this.saveObj.version = row.version;
        this.saveObj.author = row.author;
        console.log(row.start_date + "-----" + row.end_date);
        this.saveObj.termOfValidity = [];
        if ((row.start_date && row.start_date != "") || (row.end_date && row.end_date != "")) {
          this.saveObj.termOfValidity = [row.start_date != "" ? row.start_date : "", row.end_date != "" ? row.end_date : row.end_date];
        }
        this.saveObj.sub_title = row.sub_title;
        this.saveObj.call_script = row.call_script;
        this.saveObj.category = row.category;
        this.type = row.category;
        this.saveObj.classifed = row.classifed == "T" ? true : false;
        this.saveObj.recommended = row.recommended == "T" ? true : false;
        this.saveObj.status = row.status == "ACTIVE" ? true : false;
        for (let i = 0; i < row.productArray.length; i++) {
          const element = row.productArray[i];
          if (element.product_id) {
            this.saveObj.productArray.push(element.product_id);
          }
        }
        this.saveObj.thumbnail.id = row.thumbnail;
        if (row.thumbnail && row.thumbnail != "") {
          this.saveObj.thumbnail.name = row.thumbnail;
          this.saveObj.thumbnail.url = await this.getImgUrl(row.thumbnail);
          console.log("-------------thumbnail---------");
          console.log(this.saveObj.thumbnail.url);
          this.fileThumList = [
            {
              name: this.saveObj.thumbnail.name,
              url: this.saveObj.thumbnail.url,
            },
          ];
        }
        this.saveObj.coverImg.id = row.photo_id;
        if (row.photo_id && row.photo_id != "") {
          this.saveObj.coverImg.name = row.photo_id;
          console.log("==================");
          this.saveObj.coverImg.url = await this.getImgUrl(row.photo_id);
          console.log("-------------coverImg---------");
          console.log(this.saveObj.coverImg.url);
          this.fileCoverList = [
            {
              name: this.saveObj.coverImg.name,
              url: this.saveObj.coverImg.url,
            },
          ];
        }
        this.uploadConverDisabled = this.fileCoverList.length >= 1;
        this.uploadThumDisabled = this.fileThumList.length >= 1;
      },
      //关闭弹窗
      quxiao(isy = true) {
        // this.$refs["form"].clearValidate();

        for (let key in this.saveObj) {
          let item = this.saveObj[key];
          if (item instanceof Array) {
            this.saveObj[key] = [];
          } else if (item instanceof Object) {
            this.saveObj[key] = {};
          } else if (item instanceof Boolean) {
            this.saveObj[key] = false;
          } else {
            this.saveObj[key] = "";
          }
        }
        for (let key in this.uploadObj) {
          let item = this.uploadObj[key];
          if (item instanceof Array) {
            this.uploadObj[key] = [];
          } else if (item instanceof Object) {
            this.uploadObj[key] = {};
          } else if (item instanceof Boolean) {
            this.uploadObj[key] = false;
          } else {
            this.uploadObj[key] = "";
          }
        }
        for (let key in this.video) {
          let item = this.video[key];
          if (item instanceof Array) {
            this.video[key] = [];
          } else if (item instanceof Object) {
            this.video[key] = {};
          } else {
            this.video[key] = "";
          }
        }
        for (let key in this.doc) {
          let item = this.doc[key];
          if (item instanceof Array) {
            this.doc[key] = [];
          } else if (item instanceof Object) {
            this.doc[key] = {};
          } else {
            this.doc[key] = "";
          }
        }
        for (let key in this.pic) {
          let item = this.pic[key];
          if (item instanceof Array) {
            this.pic[key] = [];
          } else if (item instanceof Object) {
            this.pic[key] = {};
          } else {
            this.pic[key] = "";
          }
        }
        for (let key in this.text) {
          let item = this.text[key];
          if (item instanceof Array) {
            this.text[key] = [];
          } else if (item instanceof Object) {
            this.text[key] = {};
          } else {
            this.text[key] = "";
          }
        }
        this.albumCheckList = [];
        this.tagCheckList = [];
        this.fileCoverList = [];
        this.fileThumList = [];
        this.uploadConverDisabled = false;
        this.uploadThumDisabled = false;
        this.fileList = [];
        this.fileSaveList = [];
        if (isy) {
          if (this.$refs["form"]) {
            this.$refs["form"].clearValidate();
          }
          if (this.$refs["formFile"]) {
            this.$refs["formFile"].clearValidate();
          }
          if (this.$refs["formVersion"]) {
            this.$refs["formVersion"].clearValidate();
          }
          this.dialogUploadVisible = false;
          this.dialogUploadVersionVisible = false;
          this.dialogVisible_add = false;
          this.dialogVisible_edit = false;
          this.dialogVisible_Album = false;
          this.dialogVisible_Tag = false;
        }
      },
      openDialogAdd() {
        this.$refs["form"].clearValidate();
        this.$refs["formFile"].clearValidate();
      },
      openDialogEdit() {
        this.$refs["form"].clearValidate();
      },
      openUploadDialog() {
        this.$refs["form"].clearValidate();
      },
      openUploadVersionDialog() {
        this.$refs["formVersion"].clearValidate();
      },
      openDialogAlbum() {
        this.$refs["form"].clearValidate();
      },
      openDialogTag() {
        this.$refs["form"].clearValidate();
      },
      //提交添加基本信息
      submitForm() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.addEditType === "edit") {
              this.dialogVisible_edit = false;
              this.updateBaseInfo();
              this.quxiao();
            } else {
              this.$refs["formFile"].validate((valid2) => {
                if (valid2) {
                  this.dialogVisible2 = false;
                  this.saveBaseInfo();
                }
              });
            }
          }
        });
      },
      //添加基本信息
      async saveBaseInfo() {
        try {
          let startDate = this.saveObj.termOfValidity.length > 0 ? moment(this.saveObj.termOfValidity[0]).format("YYYY-MM-DD") : "";
          let endDate = this.saveObj.termOfValidity.length > 1 ? moment(this.saveObj.termOfValidity[1]).format("YYYY-MM-DD") : "";

          let json2 = JSON.stringify(this.fileSaveList);

          if (this.video.min === "") {
            this.video.min = 0;
          }
          if (this.video.miao === "") {
            this.video.miao = 0;
          }

          let coverImg = [
            {
              file_size: this.saveObj.coverImg.file_size,
              file_id: this.saveObj.coverImg.id,
              file_name: this.saveObj.coverImg.name,
              file_type: this.saveObj.coverImg.file_type,
            },
          ];
          let thumImg = [
            {
              file_size: this.saveObj.thumbnail.file_size,
              file_id: this.saveObj.thumbnail.id,
              file_name: this.saveObj.thumbnail.name,
              file_type: this.saveObj.thumbnail.file_type,
            },
          ];
          let version = this.onModelType().version;
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id, //必填
            user_id: this.$store.getters.getUser.user_id, //必填
            title: this.saveObj.title,
            sub_title: this.saveObj.sub_title,
            size: 0,
            duration: 0,
            icon: "",
            photo_id: this.saveObj.coverImg.id,
            version: version,
            url: "",
            thumbnail: this.saveObj.thumbnail.id,
            author: this.saveObj.author,
            call_script: this.saveObj.call_script,
            start_date: startDate,
            end_date: endDate,
            classifed: this.saveObj.classifed == true ? "T" : "F",
            recommended: this.saveObj.recommended == true ? "T" : "F",
            status: this.saveObj.status == true ? "ACTIVE" : "INACTIVE",
            productArray: this.saveObj.productArray,
            category: this.type,
            coverFile: JSON.stringify(coverImg),
            thumFile: JSON.stringify(thumImg),
            url: this.text.blogUrl,
            duration: parseInt(this.video.min) * 60 + parseInt(this.video.miao), //播放时长
            files: json2,
          };
          debugger;
          console.log(data);
          await http.post("/echo/webLibrary/savelibMaterialInfo", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.quxiao();
              this.$message({
                type: "success",
                message: "保存成功",
              });
              setTimeout(() => {
                this.myfileList();
              }, 200);
            }
          });
        } catch (err) {
          this.error();
        }
      },
      //更新基本信息
      async updateBaseInfo() {
        try {
          console.log("------------termOfValidity---------");
          console.log(this.saveObj.termOfValidity);
          let startDate = this.saveObj.termOfValidity.length > 0 ? (this.saveObj.termOfValidity[0] != "" ? moment(this.saveObj.termOfValidity[0]).format("YYYY-MM-DD") : "") : "";
          let endDate = this.saveObj.termOfValidity.length > 1 ? (this.saveObj.termOfValidity[1] != "" ? moment(this.saveObj.termOfValidity[1]).format("YYYY-MM-DD") : "") : "";

          let coverImg = [
            {
              file_size: this.saveObj.coverImg.file_size,
              file_id: this.saveObj.coverImg.id,
              file_name: this.saveObj.coverImg.name,
              file_type: this.saveObj.coverImg.file_type,
            },
          ];
          console.log(coverImg);
          let thumImg = [
            {
              file_size: this.saveObj.thumbnail.file_size,
              file_id: this.saveObj.thumbnail.id,
              file_name: this.saveObj.thumbnail.name,
              file_type: this.saveObj.thumbnail.file_type,
            },
          ];
          console.log(thumImg);
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id, //必填
            user_id: this.$store.getters.getUser.user_id, //必填
            library_id: this.saveObj.library_id,
            material_id: this.saveObj.material_id,
            title: this.saveObj.title,
            sub_title: this.saveObj.sub_title,
            icon: "",
            photo_id: this.saveObj.coverImg.id,
            version: this.saveObj.version,
            url: "",
            thumbnail: this.saveObj.thumbnail.id,
            author: this.saveObj.author,
            call_script: this.saveObj.call_script,
            start_date: startDate,
            end_date: endDate,
            classifed: this.saveObj.classifed == true ? "T" : "F",
            recommended: this.saveObj.recommended == true ? "T" : "F",
            status: this.saveObj.status == true ? "ACTIVE" : "INACTIVE",
            productArray: this.saveObj.productArray,
            category: this.type,
            coverFile: JSON.stringify(coverImg),
            thumFile: JSON.stringify(thumImg),
          };
          debugger;
          console.log(data);
          await http.post("/echo/webLibrary/updatelibMaterialInfo", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.$message({
                type: "success",
                message: "保存成功",
              });
              setTimeout(() => {
                this.myfileList();
              }, 200);
            }
          });
        } catch (err) {
          this.error();
        }
      },
      handlePreview(file) {
        console.log(file);
      },
      //选择版本后重新读取版本数据
      async changeSelectVersion(value) {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id, //必填
            user_id: this.$store.getters.getUser.user_id, //必填
            library_id: this.uploadObj.library_id, //必填
            material_id: this.uploadObj.material_id, //必填
            version: value,
          };
          // this.loading = true;
          await http.post("/echo/webLibrary/getListByVersion", data).then((res) => {
            debugger;
            console.log("------changeSelectVersion-----");
            console.log(res.data);
            let row = {
              versions: res.data,
            };

            this.setEditUploadVersion(row);
          });
        } catch (err) {
          this.loading = false;
        }
      },
      //打开版本编辑
      async handleOpenUpload(index, row) {
        console.log(row);
        this.quxiao(false);
        this.uploadObj.library_id = row.library_id;
        this.uploadObj.material_id = row.material_id;
        this.uploadObj.category = row.category;
        this.type = row.category;

        if (row.category) {
          await this.getVersionArray_fn(index, row, '');
        }

        this.dialogUploadVisible = true;

        this.setEditUploadVersion(row);
      },
      async setEditUploadVersion(row) {
        if (row.versions.length == 0) {
          await this.changeSelectVersion(this.versionArray[0].version);
        } else {
          this.uploadObj.status = row.versions[0].status ? row.versions[0].status : ""
          this.uploadObj.version = row.versions[0].version ? row.versions[0].version : "";

          this.uploadObj.comments = row.versions[0].comments ? row.versions[0].comments : "";
          this.uploadObj.lastdate = moment(row.versions[0].timestamp).format("YYYY-MM-DD HH:mm");
          if (this.uploadObj.category === "BLOG") {
            this.uploadObj.blogUrl = row.versions[0].url;
          }
          this.fileList = [];
          this.fileSaveList = [];

          if (this.uploadObj.category === "VIDEO") {
            this.type = "VIDEO";
            if (row.versions.length > 0) {
              this.video.min = parseInt(parseInt(row.versions[0].duration) / 60);
              this.video.miao = parseInt(row.versions[0].duration) % 60;
              row.versions.forEach((item) => {
                if (item.files) {
                  item.files.name = item.files.file_name;
                  item.files.url = item.files.file_id;
                  this.fileSaveList.push(item.files);
                  this.fileList.push(item.files);
                }
              });
              this.video.id = row.versions[0].file_id;
            }
            console.log(this.fileList);
          } else if (this.uploadObj.category === "DOCUMENT") {
            this.type = "DOCUMENT";
            if (row.versions.length > 0) {
              // let that = this;
              row.versions.forEach((item) => {
                if (item.files) {
                  item.files.name = item.files.file_name;
                  item.files.url = item.files.file_id;
                  this.fileSaveList.push(item.files);
                  this.fileList.push(item.files);
                }
              });
              console.log(this.fileList);
              this.doc.pdfId = row.versions[0].file_id;
            }
            console.log(this.fileList);
          } else if (this.uploadObj.category === "PICTURE") {
            this.type = "PICTURE";
            //                    this.imgUrls=[]
            debugger;
            if (row.versions.length > 0) {
              for (let i = 0; i < row.versions.length; i++) {
                let version = row.versions[i];
                if (version.files) {
                  row.versions[i].files.name = row.versions[i].files.file_name;

                  let url = await this.getImgUrl(row.versions[i].file_id);
                  row.versions[i].files.url = url;
                  this.fileList.push(version.files);
                  this.fileSaveList.push(version.files);
                  this.pic.picsUrls.push(version.files);
                }
              }
              // this.pic.picsUrls = this.fileList;
            }
            console.log(this.fileList);
          }

        }

      },

      //内容编辑
      handleEditUpload(status) {
        if (this.type != "BLOG") {
          // formVersion
          this.$refs["formContent"].validate((valid) => {
            if (valid) {
              if (this.fileSaveList.length > 0) {
                this.uploadObj.status = status;
                this.editFile();
              } else {
                this.error("请上传文件");
              }
            }
          });
        } else {
          this.uploadObj.status = status;
          this.editFile();
        }
      },
      //内容编辑file
      async editFile() {
        debugger;
        try {
          console.log("==========editFile=========");
          console.log(this.fileSaveList);
          let json2 = this.fileSaveList.length > 0 ? JSON.stringify(this.fileSaveList) : "";

          if (this.video.min === "") {
            this.video.min = 0;
          }
          if (this.video.miao === "") {
            this.video.miao = 0;
          }
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id, //必填
            user_id: this.$store.getters.getUser.user_id, //必填
            library_id: this.uploadObj.library_id, //必填
            material_id: this.uploadObj.material_id, //必填
            comments: this.uploadObj.comments,
            version: this.uploadObj.version,
            category: this.type,
            duration: parseInt(this.video.min) * 60 + parseInt(this.video.miao), //播放时长
            files: json2,
            url: this.uploadObj.blogUrl,
            status: this.uploadObj.status
          };
          debugger;
          console.log("---------------editFile-----------");
          console.log(data);
          await http.post("/echo/webLibrary/saveFile", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.$message({
                type: "success",
                message: "保存成功",
              });
              this.quxiao();
              setTimeout(() => {
                this.myfileList();
              }, 200);
            } else {
              this.error(res.msg);
            }
          });
        } catch (err) {
          this.error(err);
        }
      },

      //打开版本编辑
      async handleOpenVersionUpload(index, row) {
        this.quxiao(false);
        console.log(row);
        this.uploadObj.library_id = row.library_id;
        this.uploadObj.material_id = row.material_id;
        this.uploadObj.version = "";
        this.uploadObj.comments = "";
        this.fileList = [];
        this.fileSaveList = [];
        this.type = row.category;

        this.dialogUploadVersionVisible = true;
      },
      //添加新版本
      handleAddVersionUpload(status) {
        if (this.type != "BLOG") {
          if (this.fileSaveList.length > 0) {
            this.uploadObj.status = status;
            this.addFile();
          } else {
            this.error("请上传文件");
          }
        } else {
          this.uploadObj.status = status;
          this.addFile();
        }
      },
      //添加新版本
      async addFile() {
        debugger;
        try {
          console.log("=========addFile==========");
          console.log(this.fileSaveList);
          let json2 = this.fileSaveList.length > 0 ? JSON.stringify(this.fileSaveList) : "";

          if (this.video.min === "") {
            this.video.min = 0;
          }
          if (this.video.miao === "") {
            this.video.miao = 0;
          }
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id, //必填
            user_id: this.$store.getters.getUser.user_id, //必填
            library_id: this.uploadObj.library_id, //必填
            material_id: this.uploadObj.material_id, //必填
            status: this.uploadObj.status,
            comments: this.uploadObj.comments,
            version: this.uploadObj.version,
            category: this.type,
            duration: parseInt(this.video.min) * 60 + parseInt(this.video.miao), //播放时长
            files: json2,
            url: this.uploadObj.blogUrl,
          };
          debugger;
          console.log("---------------addFile-----------");
          console.log(data);
          await http.post("/echo/webLibrary/saveVersion", data).then((res) => {
            console.log(res);
            if (res.success) {
              this.$message({
                type: "success",
                message: "保存成功",
              });
              this.quxiao();
              setTimeout(() => {
                this.myfileList();
              }, 200);
            } else {
              this.error(res.msg);
            }
          });
        } catch (err) {
          this.error(err);
        }
      },

      //打开专辑
      handleOpenAlbum(index, row, type) {
        this.openAlbumTagType = type;
        if (type == "edit") {
          this.isSearchSelect = false;
          this.albumCheckList = [];
          debugger;
          for (let i = 0; i < row.catalogArray.length; i++) {
            const element = row.catalogArray[i];
            this.albumCheckList.push(element.catalog_id);
          }
          this.selectRow = row;
        } else if (type == "search") {
          this.isSearchSelect = true;
          this.albumCheckList = this.albumSearchCheckList;
          if (this.albumSearchCheckList.length > 0) {
            this.isSearchAlbum = true;
          } else {
            this.isSearchAlbum = false;
          }
        }
        this.dialogVisible_Album = true;
      },
      //选择专辑
      changeAlbum(e) {
        console.log(e);
        debugger;
        this.albumCheckList = e;
        if (this.isSearchSelect) {
          this.albumSearchCheckList = e;
          if (this.albumSearchCheckList.length > 0) {
            this.isSearchAlbum = true;
          } else {
            this.isSearchAlbum = false;
          }
        }
      },
      //选择标签
      changeTag(e) {
        console.log(e);
        debugger;
        this.tagCheckList = e;
        if (this.isSearchSelect) {
          this.tagSearchCheckList = e;
          if (this.tagSearchCheckList.length > 0) {
            this.isSearchTags = true;
          } else {
            this.isSearchTags = false;
          }
        }
      },
      //查询专辑
      async handleSureAlbum() {
        this.myfileList(false);
        this.dialogVisible_Album = false;
      },
      //保存专辑
      async handleSaveAlbum() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id, //必填
          user_id: this.$store.getters.getUser.user_id, //必填
          library_id: this.selectRow.library_id, //必填
          material_id: this.selectRow.material_id, //必填
          catalog_ids: this.albumCheckList,
        };
        debugger;
        console.log("---------------handleSaveAlbum-----------");
        console.log(data);
        await http.post("/echo/webLibrary/updateCatalogById", data).then((res) => {
          console.log(res);
          if (res.success) {
            this.$message({
              type: "success",
              message: "保存成功",
            });
            this.quxiao();
            setTimeout(() => {
              this.myfileList();
            }, 200);
          } else {
            this.error("保存失败");
          }
        });
      },

      //打开标签
      handleOpenTag(index, row, type) {
        this.openAlbumTagType = type;
        if (type == "edit") {
          this.isSearchSelect = false;
          this.tagCheckList = [];
          debugger;
          for (let i = 0; i < row.tags.length; i++) {
            const element = row.tags[i];
            this.tagCheckList.push(element.tag_id);
          }
          this.selectRow = row;
        } else if (type == "search") {
          this.isSearchSelect = true;
          this.tagCheckList = this.tagSearchCheckList;
          if (this.tagSearchCheckList.length > 0) {
            this.isSearchTags = true;
          } else {
            this.isSearchTags = false;
          }
        }
        this.dialogVisible_Tag = true;
      },

      //根据tags查询列表
      async handleSureTag() {
        this.dialogVisible_Tag = false;
        this.myfileList(false);
      },
      //保存标签
      async handleSaveTag() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id, //必填
          user_id: this.$store.getters.getUser.user_id, //必填
          library_id: this.selectRow.library_id, //必填
          material_id: this.selectRow.material_id, //必填
          tags: this.tagCheckList,
        };
        debugger;
        console.log("---------------handleSaveTag-----------");
        console.log(data);
        await http.post("/echo/webLibrary/setMaterialTagList", data).then((res) => {
          console.log(res);
          if (res.success) {
            this.$message({
              type: "success",
              message: "保存成功",
            });
            this.quxiao();
            setTimeout(() => {
              this.myfileList();
            }, 200);
          } else {
            this.error("保存失败");
          }
        });
      },

      async downloadFile(row) {
        try {
          if (!(row.versions && row.versions.length > 0)) {
            this.error("请先添加新版本");
            return;
          }

          this.loading = true;

          debugger;
          for (let i = 0; i < row.versions.length; i++) {
            let Body = new FormData();
            Body.append("credential", "58f09f86-694c-472d-bb63-64f9be093fd2");
            Body.append("file_ids", row.versions[i].file_id);
            Body.append("tenant_id", this.$store.getters.getUser.tenant_id);
            Body.append("reference_obj", "CLIENT");
            Body.append("reference_id", "com.saasyun.web");

            var config = {
              headers: { "Content-Type": "multipart/form-data; boundary====0xKhTmLbOuNdArY" },
            }; //添加请求头
            let data = {
              credential: "58f09f86-694c-472d-bb63-64f9be093fd2",
              file_ids: row.versions[i].file_id,
              tenant_id: this.$store.getters.getUser.tenant_id,
              reference_obj: "CLIENT",
              reference_id: "com.saasyun.web",
              headersContentType: "multipart/form-data",
            };
            debugger;
            await http
              .post("/files/downloadfiles", data) //
              .then((response) => {
                if (response.success) {
                  // downloadFile(response.data[0].url);
                  console.log(response.data[0]);
                  downloadFileRename(response.data[0].url, response.data[0].fileinfo.file_name.S);
                }
              });
          }

          this.loading = false;
        } catch (err) {
          this.loading = false;
          //                    this.error()
        }
      },

      //发布 下架
      async handlePublished(row, value) {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id, //必填
          user_id: this.$store.getters.getUser.user_id, //必填
          library_id: row.library_id, //必填
          material_id: row.material_id, //必填
          status: value,
        };
        debugger;
        console.log("---------------handleSaveTag-----------");
        console.log(data);
        await http.post("/echo/webLibrary/offShelfMaterial", data).then((res) => {
          console.log(res);
          if (res.success) {
            this.$message({
              type: "success",
              message: "设置成功",
            });
            setTimeout(() => {
              this.myfileList();
            }, 200);
          } else {
            this.error("设置失败");
          }
        });
      },

      // 上传封面图片前的验证
      beforeCoverImgUpload(file) {
        debugger;
        console.log(JSON.stringify(file));
        const isPic = file.type === "application/x-jpg" || file.type === "image/jpeg" || file.type === "application/x-png" || file.type === "image/png";
        const isLt20M = file.size / 1024 / 1024 < 20 * 1.2;
        this.file_size = file.size;

        if (!isPic) {
          this.error("上传图片只能是 jpg 或png 格式!");
        }
        if (!isLt20M) {
          this.error("上传图片大小不能超过 20MB!");
        }
        const nameArr = file.name.split(".");
        console.log(nameArr);
        this.saveObj.coverImg.type = nameArr[nameArr.length - 1];
        console.log(JSON.stringify(this.saveObj));
        return isPic && isLt20M;
      },
      // 上传封面图片成功
      handleCoverImgSuccess(res, file) {
        console.log("----------------res----------");
        console.log(res);
        console.log("----------------file----------");
        console.log(file);
        debugger;
        if (res.success === true) {
          this.saveObj.coverImg.id = res.data.s3filename;
          this.saveObj.coverImg.name = res.data.filename;
          this.saveObj.coverImg.file_type = res.data.filetype;
          this.saveObj.coverImg.file_size = res.data.filesize;
          this.saveObj.coverImg.url = file.url;

          this.fileCoverList = [
            {
              name: this.saveObj.coverImg.name,
              url: this.saveObj.coverImg.url,
            },
          ];
        } else {
          this.error("上传失败");
        }
      },
      changeCoverUpload(file, fileList) {
        console.log("--------changeCoverUpload------");
        console.log(file);
        console.log(fileList);
        this.uploadConverDisabled = fileList.length >= 1;
        console.log("--------uploadConverDisabled------");
        console.log(this.uploadConverDisabled);
      },
      removeCoverImg(file, fileList) {
        console.log("--------removeCoverImg------");
        console.log(file);
        console.log(fileList);
        this.uploadConverDisabled = fileList.length >= 1;
        console.log("--------uploadConverDisabled------");
        console.log(this.uploadConverDisabled);
      },
      changeThumUpload(file, fileList) {
        console.log("--------changeThumUpload------");
        console.log(file);
        console.log(fileList);
        this.uploadThumDisabled = fileList.length >= 1;
        console.log("--------uploadThumDisabled------");
        console.log(this.uploadThumDisabled);
      },
      removeThumImg(file, fileList) {
        console.log("--------removeThumUpload------");
        console.log(file);
        console.log(fileList);
        this.uploadThumDisabled = fileList.length >= 1;
        console.log("--------uploadThumDisabled------");
        console.log(this.uploadThumDisabled);
      },
      // 上传缩略图图片验证
      beforeThumImgUpload(file) {
        debugger;
        console.log(JSON.stringify(file));
        const isPic = file.type === "application/x-jpg" || file.type === "image/jpeg" || file.type === "application/x-png" || file.type === "image/png";
        const isLt20M = file.size / 1024 / 1024 < 20 * 1.2;
        this.file_size = file.size;

        if (!isPic) {
          this.error("上传图片只能是 jpg 或png 格式!");
        }
        if (!isLt20M) {
          this.error("上传图片大小不能超过 20MB!");
        }
        const nameArr = file.name.split(".");
        console.log(nameArr);
        this.saveObj.coverImg.type = nameArr[nameArr.length - 1];
        console.log(JSON.stringify(this.saveObj));
        return isPic && isLt20M;
      },
      // 上传缩略图片成功
      handleThumImgSuccess(res, file) {
        console.log("----------------res----------");
        console.log(res);
        console.log("----------------file----------");
        console.log(file);
        debugger;
        if (res.success === true) {
          this.saveObj.thumbnail.id = res.data.s3filename;
          this.saveObj.thumbnail.name = res.data.filename;
          this.saveObj.thumbnail.file_type = res.data.filetype;
          this.saveObj.thumbnail.file_size = res.data.filesize;
          this.saveObj.thumbnail.url = file.url;

          this.fileThumList = [
            {
              name: this.saveObj.thumbnail.name,
              url: this.saveObj.thumbnail.url,
            },
          ];
        } else {
          this.error("上传失败");
        }
      },
      handlePictureCardPreview(file) {
        console.log(JSON.stringify(file));
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },

      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前已存在一个文件，请先删除该文件`);
        //`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      //图片
      handleRemove(file, fileList) {
        console.log(file, fileList);

        this.fileList = fileList;

        console.log("------------删除前------------");
        console.log(this.fileSaveList);

        if (fileList.length === 0) {
          // this.pic.picsUrls = [];
          // this.video.id = "";
          // this.audio.id = "";
          // this.doc.pdfId = "";
          // this.ppt.id = "";
          this.fileSaveList = [];
        } else {
          this.fileSaveList = [];
          fileList.forEach((item) => {
            if (item.response) {
              let obj = {
                file_id: item.response.data.s3filename,
                file_name: item.response.data.filename,
                file_type: item.response.data.filetype,
                file_size: item.response.data.filesize,
              };
              this.fileSaveList.push(obj);
            } else {
              let obj = {
                file_id: item.file_id,
                file_name: item.file_name,
                file_type: item.file_type,
                file_size: item.file_size,
              };
              this.fileSaveList.push(obj);
            }
          });
        }
        console.log("------------删除后------------");
        console.log(this.fileSaveList);
        // for (var i = 0; i < this.pic.picsUrls.length; i++) {
        //     var pic = this.pic.picsUrls[i];
        //     if (pic.id == file.response.data.id) {
        //         this.pic.picsUrls.splice(i, 1);
        //         return;
        //     }
        // }
      },
      // 视频上传前的验证
      beforeVideoUpload(file) {
        const isMp4 = file.type === "video/mpeg4" || file.type === "video/mp4";
        const isLt100M = file.size / 1024 / 1024 < 100 * 1.2;
        this.file_size = file.size;
        if (!isMp4) {
          this.error("上传的文件只能是 mp4 格式!");
        }
        if (!isLt100M) {
          this.error("上传的文件大小不能超过 100MB!");
        }
        const nameArr = file.name.split(".");
        this.video.type = nameArr[nameArr.length - 1];
        var b = isMp4 && isLt100M;

        if (b) {
          this.canUpload = false;
        }

        return b;
      },
      // 视频上传成功
      handleVideoSuccess(res, file, fileList) {
        console.log("----------------res----------");
        console.log(res);
        console.log("----------------file----------");
        console.log(file);
        this.canUpload = true;
        if (res.success === true) {
          this.video.videoUrl = res.data.url;
          this.video.id = res.data.s3filename;
          this.video.fileName = file.name;
          //                    this.Mlist.push(res.data)

          this.Mlist = [];
          this.fileSaveList = [];
          fileList.forEach((item) => {
            if (item.response) {
              let obj = {
                file_id: item.response.data.s3filename,
                file_name: item.response.data.filename,
                file_type: item.response.data.filetype,
                file_size: item.response.data.filesize,
              };
              this.fileSaveList.push(obj);
              this.Mlist.push(obj);
              if (this.Mlist.length > 1) {
                this.Mlist.shift();
              }
            } else {
              let obj = {
                file_id: item.file_id,
                file_name: item.file_name,
                file_type: item.file_type,
                file_size: item.file_size,
              };
              this.fileSaveList.push(obj);
            }
          });
          if (fileList.length > 1) {
            fileList.shift();
          }
          console.log("----------------fileList----------");
          console.log(fileList);
          this.fileList = fileList;
          this.$refs["video"].clearValidate();
        } else {
          this.error("上传文件失败");
        }
      },

      // 上传图片成功
      handleImgSuccess(res, file, fileList) {
        debugger;
        console.log("----------------res----------");
        console.log(res);
        console.log("----------------file----------");
        console.log(file);
        console.log("----------------fileList----------");
        console.log(fileList);
        if (res.success === true) {
          // this.Tlist = [];
          this.fileSaveList = [];
          fileList.forEach((item) => {
            if (item.response) {
              let obj = {
                file_id: item.response.data.s3filename,
                file_name: item.response.data.filename,
                file_type: item.response.data.filetype,
                file_size: item.response.data.filesize,
              };
              this.fileSaveList.push(obj);
              this.pic.picsUrls[this.pic.picsUrls.length - 1] = obj;
              // this.Tlist.push(obj);
            } else {
              let obj = {
                file_id: item.file_id,
                file_name: item.file_name,
                file_type: item.file_type,
                file_size: item.file_size,
              };
              this.fileSaveList.push(obj);
              this.pic.picsUrls[this.pic.picsUrls.length - 1] = obj;
            }
          });
          // this.pic.picsUrls[this.pic.picsUrls.length - 1].id = res.data.s3filename;
          // this.pic.picsUrls[this.pic.picsUrls.length - 1].url = res.data.url;
          // this.pic.picsUrls[this.pic.picsUrls.length - 1].size = file.size;
          // this.pic.picsUrls[this.pic.picsUrls.length - 1].fileName = file.name;
          this.fileList = fileList;
          // this.$refs.picUpload.clearValidate();
        } else {
          this.error("上传失败");
        }
        console.log(this.pic);
      },
      // 上传图片前的验证
      beforeImgUpload(file) {
        debugger;
        console.log(JSON.stringify(file));
        const isPic = file.type === "application/x-jpg" || file.type === "image/jpeg" || file.type === "application/x-png" || file.type === "image/png";
        const isLt20M = file.size / 1024 / 1024 < 20 * 1.2;
        this.file_size = file.size;

        if (!isPic) {
          this.error("上传图片只能是 jpg 或png 格式!");
        }
        if (!isLt20M) {
          this.error("上传图片大小不能超过 20MB!");
        }
        const nameArr = file.name.split(".");
        console.log(nameArr);
        this.pic.picsUrls.push({ type: nameArr[nameArr.length - 1], status: "success" });
        console.log("----------pic----");
        console.log(JSON.stringify(this.pic));
        return isPic && isLt20M;
      },

      // pdf上传成功
      handlePDFSuccess(res, file, fileList) {
        console.log("----------------res----------");
        console.log(res);
        console.log("----------------file----------");
        console.log(file);
        this.canUpload = true;
        const isLt50M = file.size / 1024 / 1024 < 50 * 1.2;
        this.file_size = file.size;
        if (res.success === true) {
          this.doc.fileName = file.name;
          this.doc.pdfId = res.data.s3filename;
          //                        this.Dlist.push(res.data)

          this.Dlist = [];
          this.fileSaveList = [];
          fileList.forEach((item) => {
            if (item.response) {
              let obj = {
                file_id: item.response.data.s3filename,
                file_name: item.response.data.filename,
                file_type: item.response.data.filetype,
                file_size: item.response.data.filesize,
              };
              this.fileSaveList.push(obj);
              this.Dlist.push(obj);
              if (this.Dlist.length > 1) {
                this.Dlist.shift();
              }
            } else {
              let obj = {
                file_id: item.file_id,
                file_name: item.file_name,
                file_type: item.file_type,
                file_size: item.file_size,
              };
              this.fileSaveList.push(obj);
            }
          });
          if (fileList.length > 1) {
            fileList.shift();
          }
          this.fileList = fileList;
          this.$refs["doc"].clearValidate();
        } else {
          this.error("上传失败");
        }
      },
      // pdf上传前的验证
      beforePDFUpload(file) {
        const isPdf = file.type === "application/pdf";
        const isLt50M = file.size / 1024 / 1024 < 50 * 1.2;
        this.file_size = file.size;

        if (!isPdf) {
          this.error("上传的文件只能是 pdf 格式!");
        }
        if (!isLt50M) {
          this.error("上传的文件大小不能超过 50MB!");
        }
        const nameArr = file.name.split(".");
        this.doc.pdfType = nameArr[nameArr.length - 1];

        var b = isPdf && isLt50M;

        if (b) {
          this.canUpload = false;
        }
        return b;
        //return isPdf && isLt50M
      },

      async getImgUrl(file_id) {
        try {
          // this.loading = true;
          let url = "";
          console.log("----------getImgUrl:" + file_id);
          let Body = new FormData();
          Body.append("credential", "58f09f86-694c-472d-bb63-64f9be093fd2");
          Body.append("file_ids", file_id);
          Body.append("tenant_id", this.$store.getters.getUser.tenant_id);
          Body.append("reference_obj", "CLIENT");
          Body.append("reference_id", "com.saasyun.android");

          var config = {
            headers: { "Content-Type": "multipart/form-data; boundary====0xKhTmLbOuNdArY" },
          }; //添加请求头
          let data = {
            credential: "58f09f86-694c-472d-bb63-64f9be093fd2",
            file_ids: file_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            reference_obj: "CLIENT",
            reference_id: "com.saasyun.android",
            headersContentType: "multipart/form-data",
          };
          debugger;
          let res = await http
            .post("/files/downloadfiles", data) //
            .then((response) => {
              if (response.success) {
                url = response.data[0].url;
              }
              console.log("--------2--getImgUrl:" + response);
            });

          console.log("------3----getImgUrl--------" + url);
          this.loading = false;
          return url;
        } catch (err) {
          this.loading = false;
        }
      },

      //预览文件
      async handlePreviewFile(row) {
        let file_id = ""
        if (row) //从列表页预览
        {
          if (row.versions.length > 0) {
            file_id = row.versions[0].file_id;
          }
        }
        else //从内容编辑预览
        {
          if (this.fileList.length > 0) {
            file_id = this.fileList[0].file_id;
          }
        }
        this.getPreviewImgUrl(file_id);

      },

      async getPreviewImgUrl(file_id) {
        this.previewUrl = "";
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id, //必填
          file_id: file_id
        };
        await http.post("/echo/webLibrary/getUnlimitedQRCode", data).then((res) => {
          console.log(res);
          if (res.success) {
            let base64Data = "data:image/jpeg;base64," + btoa(new
              Uint8Array(res.data.data).reduce((sres, byte) => sres + String.fromCharCode(byte), ''))
            console.log(base64Data);
            this.previewUrl = base64Data
            console.log(this.previewUrl);
          } else {
            this.error(res.msg);
          }
        });
      },

    },
    updated() {
      // console.log(this.tableData)
    },

  };

  // const downloadFile = (url) => {
  //     const iframe = document.createElement("iframe");
  //     iframe.style.display = "none"; // 防止影响页面
  //     iframe.style.height = 0; // 防止影响页面
  //     iframe.src = url;
  //     document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
  //     // 5分之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
  //     setTimeout(() => {
  //         iframe.remove();
  //     }, 1 * 60 * 1000);
  // };

  export function downloadFileRename(url, filename) {
    function getBlob(url) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };
        xhr.send();
      });
    }
    function saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement("a");
        // const exportBtn = document.getElementById('exportBtn')

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // fix Firefox
        link.style.display = "none";
        // exportBtn.appendChild(link)

        link.click();
        // exportBtn.removeChild(link)

        window.URL.revokeObjectURL(link.href);
        return;
      }
    }
    getBlob(url).then((blob) => {
      saveAs(blob, filename);
    });
  }
</script>

<style lang="scss" module scoped>
  .container {
    .top {}
  }
</style>
<style scoped>
  .el-button--success {
    background-color: #4ec880;
    border-color: #4ec880;
  }

  .el-button--primary {
    background-color: #4a90e2;
    border-color: #4a90e2;
  }

  .el-button--danger {
    background-color: #ed3b3f;
    border-color: #ed3b3f;
  }

  .el-button--warning {
    background-color: #ff9901;
    border-color: #ff9901;
  }

  .subjectList>>>.el-form-item__label {
    font-size: 14px;
    color: #000000;
    text-align: left;
  }
</style>
<style>
  .el-checkbox__label {
    margin-top: 3px;
  }

  .el-container {
    height: 100%;
    padding: 20px;
    background: white;
  }

  #collectionHome {
    width: 100%;
    background: white;
    position: relative;
  }

  .hide .el-upload--picture-card {
    display: none;
  }

  #collectionHome>>>.el-dialog__header {
    padding-top: 0;
  }

  #collectionHome>>>.el-form-item__label {
    font-size: 14px;
    color: black;
    font-weight: bold;
  }

  #collectionHome>>>.el-tag.el-tag--info {
    background: #ff9901;
    color: #ffffff;
    border: none;
  }

  #collectionHome>>>.el-tag.el-tag--info .el-tag__close {
    display: none;
  }

  #collectionHome>>>.collectionHome_star label:after {
    content: "*";
    color: #f56c6c;
    margin-left: 4px;
  }

  .headerStyle>div {
    font-size: 14px;
    color: #585757;
    font-weight: bold;
  }

  .headerStyle:last-of-type>div {
    color: #4a90e2;
  }

  .myElForm .el-form-item__label {
    font-weight: bold;
    color: black;
  }

  .myelformItem .el-form-item__content {
    margin: 0 !important;
  }

  .el-form-item__content .el-upload__tip:last-of-type {
    color: #4a90e2;
    font-weight: bold;
  }

  .el-form-item__content .el-upload__tip:last-of-type:after {
    content: "!";
  }

  .el-form-item__content .el-upload__tip:last-of-type>.el-icon-circle-check {
    color: green !important;
  }

  #uploadDome .upload_star label:after {
    content: "*";
    color: #f56c6c;
    margin-left: 4px;
  }

  #uploadDome .upload_star .el-upload-list__item label:after {
    content: "";
  }
</style>


// WEBPACK FOOTER //
// src/pages/echo/index.vue